import React, { Suspense } from 'react'
import { ChatAssistant, ChatMessage } from '../../types'

const CommandButtonsCore = React.lazy(() => import('./CommandButtons/CommandButtons'))

export default function CommandButtons({
  blockType,
  content,
  assistant,
  message
}: {
  blockType: string
  content: string
  assistant?: ChatAssistant
  message?: ChatMessage
}) {
  return (
    <Suspense fallback={null}>
      <CommandButtonsCore blockType={blockType} content={content} assistant={assistant} message={message} />
    </Suspense>
  )
}
